<template>
	<div>
		<el-form :model="createForm" :rules="rules" ref="createForm" :hide-required-asterisk="true" label-width="5em">
			<!--发件人-->
			<div class="blockBox">
				<div class="blockTypeName" style="background-color: #409EFF;" @click="print()">寄</div>
				<div class="contactInfo">
					<el-row :gutter="0">
						<el-col :span="11">
							<el-form-item label="姓名" prop="sender.name" :rules="rules.name">
								<el-input v-model="createForm.sender.name" placeholder="发件人名称" clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="13">
							<el-form-item label="电话" prop="sender.mobile" :rules="rules.mobile">
								<el-input v-model="createForm.sender.mobile" placeholder="手机或座机号码" clearable></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="省市区" prop="sender.area_code" :rules="rules.area" style="width: 100%;">
						<el-cascader v-model="createForm.sender.area_code" ref="sender_area"
							@change="area_change('sender')" separator=" - " placeholder="请选择发件方所在省市区信息"
							:options="areaData" :props="{label:'name',value:'adcode',children:'districts'}" clearable
							filterable style="width: 100%;"></el-cascader>
					</el-form-item>
					<el-form-item label="详细地址" prop="sender.address" :rules="rules.address">
						<el-input v-model="createForm.sender.address" placeholder="请输入发件方详细地址" clearable></el-input>
					</el-form-item>

				</div>
				<!-- 智能识别 -->
				<div class="intelligent-filling">
					<div class="structured">
						<el-input v-model="structuredInfo.sender" type="textarea" :autosize="{ minRows:4, maxRows:4}"
							placeholder="粘贴/输入发件方信息，点击智能解析，自动填写发件人信息" resize="none" clearable></el-input>
						<div class="structured-button" :disabled="false">
							<el-button type="text" @click="structured('sender',structuredInfo.sender)"
								:loading="structured_button" round>一键解析</el-button>
						</div>
					</div>
				</div>
			</div>

			<!--收件人-->
			<div class="blockBox">
				<div class="blockTypeName" style="background-color: #ff5a71;">收</div>
				<div class="contactInfo">
					<el-row :gutter="0">
						<el-col :span="11">
							<el-form-item label="姓名" prop="recipient.name" :rules="rules.name">
								<el-input v-model="createForm.recipient.name" placeholder="收件人名称" clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="13">
							<el-form-item label="电话" prop="recipient.mobile" :rules="rules.mobile">
								<el-input v-model="createForm.recipient.mobile" placeholder="手机或座机号码"
									clearable></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="省市区" prop="recipient.area_code" :rules="rules.area" style="width: 100%;">
						<el-cascader v-model="createForm.recipient.area_code" ref="recipient_area"
							@change="area_change('recipient')" separator=" - " placeholder="请选择收件方所在省市区信息"
							:options="areaData" :props="{label:'name',value:'adcode',children:'districts'}" clearable
							filterable style="width: 100%;"></el-cascader>
					</el-form-item>
					<el-form-item label="详细地址" prop="recipient.address" :rules="rules.address">
						<el-input v-model="createForm.recipient.address" placeholder="请输入收件人详细地址" style="width: 100%;"
							clearable></el-input>
					</el-form-item>
				</div>
				<!-- 智能识别 -->
				<div class="intelligent-filling">
					<div class="structured">
						<el-input v-model="structuredInfo.recipient" type="textarea" :autosize="{ minRows:4, maxRows:4}"
							placeholder="粘贴/输入收件方信息，点击智能解析，自动填写收件人信息" resize="none" clearable @focus="structured_recipient_focus=true"></el-input>
						<div class="structured-button" :disabled="false">
							<el-button type="text" @click="structured('recipient',structuredInfo.recipient)"
								:loading="structured_button" round>一键解析</el-button>
						</div>
					</div>
				</div>
			</div>

			<!--物品信息区-->
			<div class="blockBox">
				<div class="blockTypeName" style="background-color: #ff9704;">物</div>
				<el-form-item label="物品名称" prop="goods[0].name" :rules="rules.goodsName">
					<el-select v-model="createForm.goods[0].name" clearable filterable allow-create default-first-option
						placeholder="请输入物品类型">
						<el-option v-for="item in goodsList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="重量(KG)" prop="weight" style="margin-left: 3%;">
					<el-input-number v-model="createForm.goods[0].weight" controls-position="right" :step="0.10"
						:min="0.1" :max="20" placeholder="重量/KG"></el-input-number>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input type="text" placeholder="给小哥\收件人捎个话吧~(非必填)" v-model="createForm.remark" maxlength="30"
						show-word-limit clearable></el-input>
				</el-form-item>
			</div>
			<!--浮动订单提交-->
			<div
				style="position: fixed;bottom: 0%;width: 100%;left:0;background-color: #FFFFFF;z-index: 2;display: flex;align-items: center;padding: 1% 38%;border-top: 1px solid #ececec;">
				<el-button type="primary" plain @click="submit('createOrder',createForm)"
					:loading="button_loading">提交订单</el-button>
				<el-button type="primary" @click="submit('print',createForm)" :loading="button_loading"
					style="margin-left: 7%;">提交并打印</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	import {
		ElMessage,
		ElLoading
	} from 'element-plus'
	import areaData from "@/assets/areaCode.json";
	export default {
		name: 'createOrder',
		data() {
			return {
				areaData: areaData,
				orderNo: "",
				createForm: {
					sender: {
						name: "",
						mobile: "",
						area_code: [], //省市区选项code--'', '',""
						provinceName: "",
						cityName: "",
						districtName: "",
						address: "",
					},
					recipient: {
						name: "",
						mobile: "",
						area_code: [], //省市区选项code--'', '',""
						provinceName: "",
						cityName: "",
						districtName: "",
						address: "",
					},
					goods: [{
						name: '日用品',
						weight: '1'
					}],
					service: [],
					remark: "",
					source: "KD_WEB"
				},
				button_loading: false,
				//表单校验
				rules: {
					name: [{
							required: true,
							message: '姓名必填',
							trigger: 'change'
						},
						{
							min: 1,
							max: 10,
							message: '长度在 1 到 10 个字符',
							trigger: 'change'
						}
					],
					mobile: [{
							required: true,
							message: '请输入手机或座机号码',
							trigger: 'change'
						},
						{
							min: 4,
							max: 18,
							message: '请输入正确的联系电话',
							trigger: 'change'
						}
					],
					area: [{
						required: true,
						message: '请选择/输入省市区',
						trigger: 'change'
					}, ],
					address: [{
							required: true,
							message: '请输入详细的地址信息',
							trigger: 'change'
						},
						{
							min: 3,
							max: 50,
							message: '长度在 3 到 100 个字符',
							trigger: 'change'
						}
					],
					goodsName: [ //prop和v-model名称需要一致
						{
							required: true,
							message: '请选择/输入物品名称',
							trigger: 'change'
						},
					],
					goodsWeight: [{
						required: true,
						message: '请输入物品重量',
						trigger: 'change'
					}, ],
					remark: [{
						min: 1,
						max: 15  ,
						message: '长度在 1 到 30 个字符',
						trigger: 'change'
					}],
				},

				//智能解析结果
				structuredInfo: {
					sender: "",
					recipient: ""
				},
				goodsList: [{
						value: '日用品',
						label: '日用品'
					},
					{
						value: '服装饰品',
						label: '服装饰品'
					},
					{
						value: '化妆品',
						label: '化妆品'
					}, {
						value: '食品',
						label: '食品'
					},
					{
						value: '电子产品',
						label: '电子产品'
					},
					{
						value: '文件',
						label: '文件'
					},

				],
				structured_button: false,
				structured_recipient_focus:false
			}
		},
		mounted() {
			//默认发件人信息
			var default_sender_info = JSON.parse(localStorage.getItem('default_sender_info'));
			if (default_sender_info) {
				this.createForm.sender = default_sender_info;
			}

			//获取剪切板内容填到收件人智能解析里
			// 启动定时器，每5秒调用一次
			setInterval(() =>this.getClipboardContent(), 500);
			// this.getClipboardContent()
		},
		methods: {
			// 异步函数获取剪切板内容
			async getClipboardContent() {
				if(this.structured_recipient_focus==false){
					try {
						const clipboardText = await navigator.clipboard.readText();
						console.log('剪切板内容：', clipboardText);
						//字数>22个时候填充到收件人智能解析框
						if (clipboardText.length > 22 && clipboardText!= this.structuredInfo.recipient) {
							this.structuredInfo.recipient = clipboardText;
						}
					} catch (err) {
						console.error('剪切板读取异常：', err);
						return null;
					}
				}
				
			},
			//创建订单
			async createOrder() {
				//存储默认发件人信息
				localStorage.setItem('default_sender_info', JSON.stringify(this.createForm.sender));
				var orderNo = null
				const loading = ElLoading.service({
					lock: true,
					text: '创建中',
					background: 'rgba(0, 0, 0, 0.7)',
				})
				await this.apiService.post({
						modules: "createOrder",
						content: this.createForm
					})
					.then((res) => {
						//成功
						if (res.status) {
							orderNo = res.data.orderNo;
						}
					})
					.finally(() => {
						loading.close();
					})
				return orderNo
			},
			//提交
			async submit(type) {
				this.$refs['createForm'].validate(async (valid) => {
					if (valid) {
						if (!this.orderNo) {
							var createOrderRes = await this.createOrder()
							if (!createOrderRes) {
								ElMessage({
									message: '订单创建失败',
									type: 'error'
								})
								return false
							}
							this.orderNo = createOrderRes;
						}
						//判断提交方式
						if (type == "createOrder") {
							ElMessage({
								message: '创建成功',
								type: 'success'
							})
							location.reload();
						} else if (type == "print") {
							this.apiService.post({
									modules: "getOrderData",
									content: {
										orderNo: createOrderRes
									}
								})
								.then((res) => {
									//成功
									if (res.status) {
										this.waybillPrintPopup({
											orderContent: res.data.orderData,
											isReprint: false
										})
									}
								})

						}
					} else {
						return false;
					}
				});

			},
			//菜鸟打印组件
			// cainiaoPrinter_init(){ //初始化weosocket
			// 	this.cainiaoPrinter = new WebSocket("ws://localhost:13528");
			// 	this.cainiaoPrinter.onmessage = this.cainiaoPrinter_onmessage;
			// 	this.cainiaoPrinter.onopen = this.cainiaoPrinter_onopen;
			// 	this.cainiaoPrinter.onerror = this.cainiaoPrinter_onerror;
			// 	this.cainiaoPrinter.onclose = this.cainiaoPrinter_close;
			//   },
			//   cainiaoPrinter_onerror(){//连接建立失败重连
			// 	this.initWebSocket();
			//   },
			//   cainiaoPrinter_onmessage(e){ //数据接收
			// 	const cainiaoPrinter_data = JSON.parse(e.data);
			// 	console.log('cainiaoPrinter',cainiaoPrinter_data)
			// 	if(cainiaoPrinter_data.cmd=="getPrinters"){
			// 		this.printerList= cainiaoPrinter_data.printers;
			// 	}
			//   },
			//   cainiaoPrinter_close(e){  //关闭
			// 	console.log('菜鸟打印机断开连接',e);
			//   },

			//智能解析
			structured(to, text) {
				if (to && text) {
					this.structured_button = true;
					this.apiService.post({
							modules: "structured",
							content: {
								text: text
							}
						})
						.then((res) => {
							//成功
							if (res.status) {
								var structureDdata = res.data[0]
								this.createForm[to].name = structureDdata.name;
								if (structureDdata.mobile) {
									this.createForm[to].mobile = structureDdata.mobile;
								} else {
									this.createForm[to].mobile = structureDdata.tel;
								}
								//this.createForm[to].area_code=[structureDdata.areaCode.slice(0,2), structureDdata.areaCode.slice(0,4),structureDdata.areaCode]
								this.createForm[to].area_code = [structureDdata.areaCode.slice(0, 2) + '0000',
									structureDdata.areaCode.slice(0, 4) + '00', structureDdata.areaCode
								]
								// this.area_change(to); //更新省市区
								this.createForm[to].provinceName = structureDdata.provinceName;
								this.createForm[to].cityName = structureDdata.cityName;
								this.createForm[to].districtName = structureDdata.districtName;
								this.createForm[to].address = structureDdata.address;
								console.log(this.createForm)
							}
						})
						.finally(() => {
							this.structured_button = false;
						})
				} else {
					ElMessage({
						message: '请输入需要解析的文本',
						type: 'error'
					})
				}
			},

			//省市区联级选择器
			area_change(to) {
				const checkedNodes = this.$refs[to + '_area'].getCheckedNodes() // 获取当前修改的节点
				console.log(checkedNodes)
				this.createForm[to].provinceName = checkedNodes[0].pathLabels[0] //省级
				this.createForm[to].cityName = checkedNodes[0].pathLabels[1] //市级
				this.createForm[to].districtName = checkedNodes[0].pathLabels[2] //区县级
				console.log(this.createForm[to])
				/*
				解决搜索值未更新，参考：
				https://blog.csdn.net/tt18473481961/article/details/112863160
				*/
				// const checkedNodes = this.$refs[to + '_area'].getCheckedNodes() // 获取当前点击的节点
				/* console.log(this.$refs[to + '_area'].panel) */
				/* this.$refs[to + '_area'].$refs.panel.clearCheckedNodes()
				this.$refs[to + '_area'].$refs.panel.activePath = []
				this.$refs[to + '_area'].$refs.panel.scrollIntoView()
				this.$refs[to + '_area'].$refs.input.$refs.input.setAttribute('aria-expanded', false)
				this.$refs[to + '_area'].$emit('visible-change', false)
				this.$refs[to + '_area'].$refs.panel.$emit('visible-change', false)
				this.$refs[to + '_area'].$refs.panel.$emit('close')
				this.$nextTick(() => {
					var selectedNode2 = this.$refs[to + '_area'].getCheckedNodes(true)
					console.log(this.$refs[to + '_area'].getCheckedNodes())
					this.createForm[to].provinceName = selectedNode2[0].pathLabels[0] //省级
					this.createForm[to].cityName = selectedNode2[0].pathLabels[1] //市级
					this.createForm[to].districtName = selectedNode2[0].pathLabels[2] //区县级
					console.log(selectedNode2)
					console.log(this.createForm[to])
				}); */
			}

		}
	}
</script>

<style scoped>
	/**寄收件人信息**/
	.contactInfo {}

	/**块样式**/
	.blockBox {
		background-color: #fff;
		padding: 1.9% 2% 0.6% 3%;
		display: flex;
		align-items: center;
		border-radius: 4px;
	}

	.blockBox:not(:first-child) {
		margin-top: 1vh;
	}


	.blockTypeName {
		padding: 0.5em;
		font-size: 1em;
		color: #fff;
		border-radius: 8px;
		margin-right: 2%;
	}

	/**智能解析样式**/
	.intelligent-filling {
		width: 30%;
		margin-left: 6%;
	}

	.intelligent-filling .structured {
		border: 1px solid #eee;
		border-radius: 4px;
	}

	.intelligent-filling .structured .structured-button {
		margin: 1% 4% 1% 0;
		text-align: right;
		color: #3e9cf9;
		cursor: pointer;
		font-size: 1.1em;
		font-family: none;
	}

	/*去除智能解析的输入框自带边框*/
	:deep(.intelligent-filling .structured .el-textarea__inner) {
		box-shadow: none !important;
	}


	/* .name {
		text-overflow: ellipsis;
		overflow: hidden;
		color: #606266;
		font-size: 1em;
		white-space: nowrap;
	}

	.addr {
		font-size: 0.5em;
		color: #b4b4b4;
		white-space: nowrap;
	}

	.highlighted .addr {
		color: #ddd;
	}

	.el-autocomplete-suggestion li {
		line-height: 1.8em;
	}

	.address_suggestions {
		border-radius: 0.3em;
	}

	.address_suggestions_item :hover {
		background: #ecf5ff;
	}

	.el-submenu .el-menu-item {
		min-widtt: 0px;
	}



	.el-input__inner {
		border-color: #cacdd3;
	}

	.el-textarea__inner {
		border-color: #cacdd3;
	} */
</style>